var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJournalMedicalFillInverted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.998 2.935c-1.268 0-2.396.804-2.844 2.035L3.998 4.94a1.001 1.001 0 0 0 0 2.003h1v2.004h-1a1.001 1.001 0 0 0 0 2.004h1v2.003h-1a1.001 1.001 0 0 0 0 2.004h1v2.003h-1a1.001 1.001 0 0 0 0 2.004h1.188c.341 1.113 1.544 2.004 2.812 2.004h10c1.657 0 3-1.346 3-3.006V5.941a3.003 3.003 0 0 0-3-3.006h-10zm5 4.007c.552 0 1 .449 1 1.002a1.001 1.001 0 0 1 0 2.004 1.001 1.001 0 1 1-2 0 1.001 1.001 0 0 1 0-2.004c0-.553.448-1.002 1-1.002zm-3 5.01h6a1.001 1.001 0 0 1 0 2.003h-6a1.001 1.001 0 0 1 0-2.004zm0 3.005h6a1.001 1.001 0 0 1 0 2.003h-6a1.001 1.001 0 0 1 0-2.003z",
    fill: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJournalMedicalFillInverted);
export default __webpack_public_path__ + "static/media/journal-medical-fill-inverted.185e6ee8.svg";
export { ForwardRef as ReactComponent };